<template>
  <!-- 浮动 -->
  <div id="bars" v-show="fixBarShow">
    <div class="content">
      <Nav :flexible="true"></Nav>
      <div class="search">
        <search></search>
      </div>
      <div class="menuitem">
        <TopMenuItem></TopMenuItem>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./Nav.vue";
import search from "./search.vue";
import TopMenuItem from "./TopMenuItem.vue";
export default {
  components: {
    Nav: Nav,
    search: search,
    TopMenuItem: TopMenuItem,
  },
  data: function () {
    return {
      fixBarShow: false,
    };
  },
  computed: {
    topboxConfig: function () {
      return this.$store.state.malMainPageConfig.topbox;
    },
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 90) {
        this.fixBarShow = true;
      } else {
        this.fixBarShow = false;
      }
    },
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
#bars {
  width: 100%;
  height: 60px;
  background-color: #ffffff;
  border-bottom: 1px solid #ffffff;
  display: flex;
  align-items: center;
  z-index: 7650;
  position: fixed;
  top: 0;
  opacity: 0.95;
}
#bars .content {
  width: 1200px;
  height: 48px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}
* {
  margin: 0;
  padding: 0;
}
div {
  display: block;
}
a {
  text-decoration: none;
}
#bars .content .search {
  margin-left: 22px;
}
</style>
